import { render, staticRenderFns } from "./Servizi.vue?vue&type=template&id=94e596fe"
import script from "./Servizi.vue?vue&type=script&lang=js"
export * from "./Servizi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports